import { toast } from "react-toastify";

export const generateReport = async (data: any, filename: string) => {
  try {
    const blob = new Blob([data], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = generateFileName(filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (error: unknown) {
    if (error instanceof Error) {
      toast.error("Failed to generate the report.", {
        position: "top-right",
        autoClose: 3000,
      });
    } else {
      toast.error("An unexpected error occurred. Please try again.");
    }
  }
};

const generateFileName = (xlfilename: string): string => {
  const now = new Date();
  const timezoneOffset = now.getTimezoneOffset();
  const hoursOffset = String(Math.abs(timezoneOffset) / 60).padStart(2, "0");
  const minutesOffset = String(Math.abs(timezoneOffset) % 60).padStart(2, "0");
  const offset = `${hoursOffset}:${minutesOffset}`;
  const date = now.toISOString().split("T")[0];
  const milliseconds = String(now.getMilliseconds()).padStart(3, "0");

  // Generate the file name and remove the specified characters
  const fileName = `${xlfilename}-${date}T${offset}${milliseconds}`.replace(/[+_\\.]/g, "");
  return `${fileName}.xlsx`;
};
